module.exports = __webpack_public_path__ + "img/theorie.2b5343fe.jpg";